var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 154,
    height: 48,
    viewBox: "0 0 154 48",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_166_1384)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M75.4797 0L38.6797 36.8L44.7697 42.89C48.1797 46.3 53.7097 46.3 57.1297 42.89L87.7497 12.27L75.4797 0Z",
    fill: "url(#paint0_linear_166_1384)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.75 12.2634L115.292 39.8052L114.38 40.7174C108.115 46.9824 97.9465 46.9824 91.6815 40.7174L75.4888 24.5247L87.75 12.2634Z",
    fill: "url(#paint1_linear_166_1384)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.0589 30.0101L69.3189 35.9401C68.9589 36.3201 69.219 36.9501 69.749 36.9501H81.219C81.739 36.9501 82.009 36.3201 81.649 35.9401L75.909 30.0101C75.679 29.7701 75.2889 29.7701 75.0589 30.0101Z",
    fill: "#8552E3"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_166_1384",
    x1: 52.2897,
    y1: 14.39,
    x2: 64.5097,
    y2: 25.4,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#028D8E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#01FCFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#01FCFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_166_1384",
    x1: 78.8451,
    y1: 16.5451,
    x2: 120.555,
    y2: 54.7451,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0986CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#01A1FE"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_166_1384"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 153.97,
    height: 95.1,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.87f6d843922d35efc04822f2094a63a8.svg";
export { ForwardRef as ReactComponent };